import { render, staticRenderFns } from "./AmDropdown.vue?vue&type=template&id=077f7b90&scoped=true&"
import script from "./AmDropdown.vue?vue&type=script&lang=js&"
export * from "./AmDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f7b90",
  null
  
)

export default component.exports